import * as React from "react";
import { PlayerState } from "../player/types";
var context = React.createContext({
    track: undefined,
    state: PlayerState.None
});
export var PlayerContextProvider = context.Provider;
export var PlayerContextConsumer = context.Consumer;
//# sourceMappingURL=player.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/context/player.js
// module id = 133
// module chunks = 0